import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess, clearError } from "./actions";

//Include Both Helper File with needed methods
import { loginPocketBase, logoutPocketBase } from "../../../helpers/pocketbase_helper";


function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "pocketbase") {
      const response = yield call(loginPocketBase, user.email, user.password);
      if (!response.record.activo) {
        yield put(apiError("Usuario no activo"));
        return;
      }
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
      yield put(clearError()); // Reset error after success
    }
    
    // Use the navigate function passed from the component
    if (history) {
      // Small delay to ensure localStorage is updated and middleware processes it
      yield delay(500);
      history("/dashboard");
    }
  } catch (error) {
    console.error('Login error:', error);
    yield put(apiError(error));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");

    if (process.env.REACT_APP_DEFAULTAUTH === "pocketbase") {
      yield call(logoutPocketBase);
      yield put(logoutUserSuccess());
    }
    history("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
